import { useEffect, useState } from "react";
import { fetchPrivateFile, privateObjectUrl, revokePrivateObjectUrl } from "../workspace/privateFiles";

export function PrivateImage({ src, alt, ...props }: { src: string; alt: string; width?: number; height?: number; loading?: "lazy" | "eager"; decoding?: "async" }) {
  const [local, setLocal] = useState<{ source: string; url: string } | null>(null);
  useEffect(() => {
    const controller = new AbortController(); let objectUrl: string | undefined;
    void fetchPrivateFile(src, controller.signal).then(blob => {
      if (controller.signal.aborted) return;
      objectUrl = privateObjectUrl(blob); setLocal({ source: src, url: objectUrl });
    }).catch(() => { if (!controller.signal.aborted) setLocal(null); });
    return () => { controller.abort(); if (objectUrl) revokePrivateObjectUrl(objectUrl); };
  }, [src]);
  return local?.source === src ? <img {...props} src={local.url} alt={alt} /> : <span aria-label={alt} />;
}
